import { OnboardingEventId } from '@thoughtspot/onboarding-event-service';
import {
    TourChainActionType,
    TourChainStep,
} from './checklist-tour-steps.util';

export const getSpotterCodeTourChain = (
    taskId: string,
    t: (key: string, params?: Record<string, unknown>) => string,
): TourChainStep[] | null => {
    switch (taskId) {
        case OnboardingEventId.EMBED_WITH_SPOTTERCODE_EMBED_WITH_AGENT:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_go_to_playground_button"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.embedWithAgent.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.embedWithAgent.content',
                            ),
                            disableBeacon: true,
                            placement: 'right-start',
                        },
                    ],
                    afterAction: {
                        selector:
                            '[data-tour-id="tour_go_to_playground_button"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    doneButtonText: t(
                        'checklistTour.discoverSpotterCode.embedWithAgent.buttonText',
                    ),
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_embed-dev-portal-chat-input-wrapper"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepOne.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepOne.content',
                            ),
                            disableBeacon: true,
                            placement: 'left-end',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotterCode.stepOne.buttonText',
                    ),
                    afterAction: {
                        selector:
                            '[data-tour-id="tour_embed-dev-portal-send-message-button"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    dismissOnAction: {
                        selector:
                            '[data-tour-id="tour_embed-dev-portal-prompts-container"]',
                        type: TourChainActionType.CLICK,
                    },
                },
                {
                    steps: [
                        {
                            target: '[data-tour-id="tour_embed-code-editor"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepTwo.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepTwo.content',
                            ),
                            disableBeacon: true,
                            placement: 'right-end',
                        },
                        {
                            target:
                                '[data-tour-id="tour_embed-dev-portal-run-button"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepThree.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepThree.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-start',
                        },
                        {
                            target:
                                '[data-tour-id="tour_embed-dev-portal-deployment-instructions"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.deploymentInstructions.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.deploymentInstructions.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-start',
                        },
                    ],
                    showProgress: true,
                    doneButtonText: t(
                        'checklistTour.discoverSpotterCode.deploymentInstructions.buttonText',
                    ),
                    onCompleteEventId:
                        OnboardingEventId.EMBED_WITH_SPOTTERCODE_EMBED_WITH_AGENT,
                },
            ];

        case OnboardingEventId.EMBED_WITH_SPOTTERCODE_EXPLORE_DEVELOPER_PORTAL:
            return [
                {
                    readyTarget: '[data-tour-id="tour_social-links-container"]',
                    steps: [
                        {
                            target: '[data-tour-id="tour_side-nav-rest-api"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.exploreDeveloperPortal.stepOne.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.exploreDeveloperPortal.stepOne.content',
                            ),
                            disableBeacon: true,
                            placement: 'right-end',
                        },
                    ],
                    onCompleteEventId:
                        OnboardingEventId.EMBED_WITH_SPOTTERCODE_EXPLORE_DEVELOPER_PORTAL,
                },
            ];

        default:
            return null;
    }
};
